import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Spinner,
  Alert,
  Col,
  Table,
  Form,
  Button,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getTransactions } from "../../slices/thunk";
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";
import withRouter from "Common/withRouter";
import { useTranslation, withTranslation } from "react-i18next";

interface JwtPayload {
  userType: string;
}
const Transactions = (props: any) => {
  document.title = "transactions";
  const { t } = useTranslation(); // ✅ React knows to update


  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }

  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState({
    show: false,
    variant: "",
    message: "",
  }); // Notification state

  const subscirbersData = useSelector(
    (state: any) => state.Payment.transactions
  );

  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(getTransactions(decoded?.userId));
  }, []);
  return (
    <React.Fragment>
      <div className="page-content">
        {notification.show && (
          <Alert
            variant={notification.variant}
            onClose={() =>
              setNotification({ show: false, variant: "", message: "" })
            }
            dismissible
          >
            {notification.message}
          </Alert>
        )}
        <Container fluid>
          <Row>
            <Col xl={12}>
              <div className="table-responsive mt-4 mt-xl-0">
                <Table className="table-hover table-striped align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th scope="col">{props.t("Payment ID")}</th>
                      <th scope="col">{t("Amount")} </th>
                      <th scope="col"> {t("Status")}</th>
                      <th scope="col">{t("Date")}</th>
                      <th scope="col">{t("Invoices")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscirbersData &&
                      subscirbersData.invoices &&
                      subscirbersData.invoices.length &&
                      subscirbersData.invoices.map((item: any) => (
                        <tr key={item.id}>
                          <td className="fw-medium">{item.id}</td>
                          <td>${item.amount_paid}</td>
                          <td>{item.status}</td>
                          <td>{item.date}</td>
                          <td>
                            <Button
                              variant="primary"
                              onClick={() =>
                                window.open(item.invoice_pdf, "_blank")
                              }
                            >
                              Download Invoice
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(Transactions));
